import { AccountStatement } from "@/modules/account/components";

export const AccountStatementPage = () => {
  return (
    <div className="full-width page-container">
      <AccountStatement/>
    </div>
  );
};
